import React from 'react';
import LinkButton from '../../LinkButton';
import { useWeddingWebsiteQuery } from '../../../generated/graphql';
import styles from './IndexWebsiteBanner.scss';
import { websiteSettingsRoute } from '../../../helpers/routes';
import { Link } from 'react-router-dom';

interface Prop {
  rightRailOpen?: boolean;
  eipRailsHandler?: () => void;
  showPublishedIndexBanner?: boolean;
}

const IndexWebsiteBanner: React.FC<Prop> = ({
  rightRailOpen = false,
  eipRailsHandler,
  showPublishedIndexBanner = false,
}) => {
  const { data: wwsData } = useWeddingWebsiteQuery();
  const isWebsitePublished = wwsData?.weddingWebsite?.state === 'published';

  const { searchable } = wwsData?.weddingWebsite || { searchable: false };

  const searchableCopy = 'Your site will appear in search engines.';
  const notSearchableCopy = "Guests can't find your site in search engines.";

  if (!isWebsitePublished) {
    return null; // If not published the publish banner should be rendered instead
  }

  if (searchable && !showPublishedIndexBanner) {
    return null;
  }

  return (
    <>
      <div className={rightRailOpen ? styles.eipIndexWebsiteBanner : styles.indexWebsiteBanner}>
        {searchable ? searchableCopy : notSearchableCopy}
        {!rightRailOpen && (
          <Link data-testid="index-banner-link" className={styles.bannerLink} to={websiteSettingsRoute}>
            Edit privacy settings
          </Link>
        )}
        {rightRailOpen && (
          <LinkButton data-testid="index-banner-button" onClick={eipRailsHandler} className={styles.bannerLink}>
            {' '}
            Edit privacy settings
          </LinkButton>
        )}
      </div>
    </>
  );
};

export default IndexWebsiteBanner;
